import React from 'react';

const statuSet = (ele, t) => {
  switch (ele?.status?.toString()) {
    case 'true':
      return (
        <>
          <span>{t('DASHBORD.TESTING.STATUS_COMP.APPROVED')}</span>
          <span className="col-status right approved" />
        </>
      );

    case 'false':
      return (
        <>
          <span>{t('DASHBORD.TESTING.STATUS_COMP.REJECTED')}</span>
          <span className="col-status right rejected" />
        </>
      );

    default:
      return (
        <>
          <span>{t('DASHBORD.TESTING.STATUS_COMP.PENDING')}</span>
          <span className="col-status right pending" />
        </>
      );
  }
};

const statusCalled = (ele, t) => {
  return ele?.status !== 'pending' || ele?.status !== 'Pending' ? (
    statuSet(ele, t)
  ) : (
    <>
      <span>{t('DASHBORD.TESTING.STATUS_COMP.PENDING')}</span>
      <span className="col-status right pending" />
    </>
  );
};

const noStatus = (ele) => {
  return ele?.createdBy ? (
    <span className="col-status right pending" />
  ) : (
    <>
      <span>--</span>
      <span className="col-status right pending" />
    </>
  );
};

export const singleStatusPart = (ele, t) => {
  return (
    <div className="position-static">
      <span>{ele?.status !== '' ? statusCalled(ele, t) : noStatus(ele)}</span>
    </div>
  );
};

export const multiStatusPart = (element, t) => {
  if (Array.isArray(element)) {
    const hasRejectOrPendingStatus = element?.some((item) => item.status !== true);
    return (
      <>
        <span>{t('DASHBORD.TESTING.STATUS_COMP.MULTIPLE')}</span>
        <span className={hasRejectOrPendingStatus ? 'col-status right pending' : 'col-status right approved'} />
      </>
    );
  }
};

export const setTitleForExp = (data, key) => {
  const dataExist = data?.some((item) => key in item && item[key] !== '' && item[key] !== null);
  return <span>{dataExist ? 'Multiple' : '--'}</span>;
};
